import React from 'react';
import {useSelector} from "react-redux";
import YearSelector from "../../components/navs/YearSelector";
import DashboardSelector from "../../components/navs/DashboardSelector";
import Dashboard from "./Dashboard";
import TaskTable from "../../components/tables/TaskTable";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import { subTaskMethod, editTaskMethod } from 'components/tasks/TaskComponent';
import { useYearTaskList } from 'hooks/taskHooks';
import MessageCenterTable from 'components/tables/MessageCenterTable';

const HomePageWidget = () => {
    const selectedDashboard = useSelector(state => state.kpi.selectedDashboard);
    const selectedYear = useSelector(state => state.kpi.selectedYear);
    const {data: userProfile} = useUserProfileQuery();
    const yearTasks =  useYearTaskList({deadlineYear: selectedYear});


    return  <div className="kpi-values-page">
                <YearSelector />
                <DashboardSelector />
                {selectedDashboard === 0 && <Dashboard />}
                {selectedDashboard === 1 && 
                        <TaskTable tasks={yearTasks}
                            newSubTaskEndpoint={subTaskMethod} 
                            editTaskEndpoint={['CompanyOwner','CompanyAdmin', 'CompanyManager'].includes(userProfile?.company?.role)? editTaskMethod : undefined}/>}

                {(selectedDashboard === 2 || selectedDashboard === 3) && 
                        <MessageCenterTable type={selectedDashboard === 2? "inbox" : "outbox"}/>
                }
    </div>;
}

export default HomePageWidget;
